import StatsWithIcon from "./StatsWithIcon";
export default StatsWithIcon;
